module.exports = __webpack_public_path__ + "static/media/Habilidades-AcessoAoM-medio.24a88cbf.png";